module.exports = __webpack_public_path__ + "static/scale-model-of-cincinnati-food-tours-in-cincinnati-ohio-7738443e4841b752cd9e73f712ab4ab5.png";